import React, { useState, useEffect } from "react";

export function MobileWarning() {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isSmallScreen = window.innerWidth < 768;
      
      if (!isMobile && !isSmallScreen) {
        setShowWarning(true);
      }
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (!showWarning) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50">
      <div className="p-6 mx-4 max-w-md bg-white rounded-lg">
        <div className="text-center">
          <div className="flex justify-center items-center mx-auto mb-4 w-20 h-20 bg-orange-100 rounded-full">
            <svg
              className="w-10 h-10 text-orange-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
          </div>
          <h2 className="mb-2 text-xl font-bold">Mobile Only Experience</h2>
          <p className="mb-6 text-gray-600">
            This Digital Collectible claiming platform is designed exclusively
            for mobile devices. Please access this application from your
            smartphone for the best experience.
          </p>
          <button
            onClick={() => setShowWarning(false)}
            className="px-4 py-3 w-full font-medium text-white bg-orange-600 rounded-lg transition-colors hover:bg-orange-700"
          >
            Continue Anyway
          </button>
          <p className="mt-3 text-sm text-gray-500">
            Some features may not work properly on desktop
          </p>
        </div>
      </div>
    </div>
  );
}